import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Vania Msg 224 · reliable back-arrow for detail pages.
 *
 * If the current location has a real history entry inside this SPA session,
 * go back one step. Otherwise (someone opened a shared link directly and
 * this is the first entry in the tab) fall through to `fallback` — which
 * defaults to /app (For You).
 *
 * We use `location.key === "default"` — react-router-dom v6/7's own signal
 * for "this is the very first entry". `window.history.length` is unreliable
 * because it also counts entries from other sites in the same tab, so
 * `nav(-1)` on a fresh-link visit could bounce the user off watu wako
 * entirely.
 */
export default function useSafeBack(fallback = "/app") {
  const nav = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.key && location.key !== "default") nav(-1);
    else nav(fallback);
  }, [nav, location.key, fallback]);
}
